import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function create(data) {
  const response = await http
    .postData("/kontrol", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function riwayat(nomor: string, tgl_awal, tgl_akhir) {
  const response = await http
    .getData(`/kontrol?nokartu=${nomor}&tgl_awal=${tgl_awal}&tgl_akhir=${tgl_akhir}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function hapus(data) {
  const response = await http
    .deleteData("/kontrol", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function edit(data) {
  const response = await http
    .putData("/kontrol", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(noSrk) {
  window.open(`${http.getAPI()}/kontrol/${noSrk}/cetak`, "_blank");
}

interface IfcSrkOnline {
  status: number
  data: {
    noSuratKontrol: string
    tglRencanaKontrol: string
    tglTerbit: string
    jnsKontrol: string
    poliTujuan: string
    namaPoliTujuan: string
    kodeDokter: string
    namaDokter: string
    flagKontrol: string
    kodeDokterPembuat: string
    namaDokterPembuat: string
    namaJnsKontrol: string
    sep: {
      noSep: string
      tglSep: string
      jnsPelayanan: string
      poli: string
      diagnosa: string
      peserta: {
        noKartu: string
        nama: string
        tglLahir: string
        kelamin: string
        hakKelas: string
      }
      provUmum: {
        kdProvider: string
        nmProvider: string
      }
      provPerujuk: {
        kdProviderPerujuk: string
        nmProviderPerujuk: string
        asalRujukan: string
        noRujukan: string
        tglRujukan: string
      }
    }
  }
  message: string
}

async function showOnline(nomor: string): Promise<IfcSrkOnline> {
  const response = await http
    .getData(`/online/surat-kontrol/${nomor}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  create,
  riwayat,
  hapus,
  print,
  edit,
  showOnline
};
